<template>
  <Dialog
    class="UppHiringProcessDialog"
    hide-title
    v-bind="$attrs"
    :display="true"
    @close="$emit('close')"
  >
    <template #content>
      <div class="UppHiringProcessDialogContent">
        <div class="artwork">
          <BaseIcon name="smartphone-mono" size="md" />
        </div>
        <h2>Autorize a consulta da Up.p</h2>
        <p>
          Acesse seu aplicativo do FGTS e permita a consulta para liberar a
          simulação.
        </p>
        <div class="upp-steps-wrapper">
          <Stepped
            v-for="(step, index) in steps"
            :key="index"
            :index="index + 1"
            :first="index === 0"
            :last="index === steps.length - 1"
          >
            {{ step }}
          </Stepped>
        </div>
      </div>
    </template>
    <template #footer>
      <Button type="primary" @click="$emit('continue')">Continuar</Button>
    </template>
  </Dialog>
</template>
<script>
import Button from '@/aasgard/components/buttons/Button.vue'
import Dialog from '@/aasgard/components/modals/Dialog.vue'
import BaseIcon from '@/aasgard/components/base/BaseIcon.vue'
import Stepped from '@/aasgard/components/feedback/Stepped.vue'
export default {
  name: 'UppHiringProcessDialog',
  components: {
    Stepped,
    Dialog,
    BaseIcon,
    Button,
  },
  props: {
    type: { type: String, default: 'warning' },
    title: { type: String, default: '' },
  },
  emits: ['close', 'continue'],
  data() {
    return {
      steps: [
        'Na página inicial do app, autorize a consulta',
        'Selecione a opção: Empréstimo Saque-Aniversário',
        'Adicione a Up.p na lista de consulta ',
        'Pronto! Agora você pode seguir com a sua simulação',
      ],
    }
  },
}
</script>
<style lang="scss">
.UppHiringProcessDialog {
  & > .content-wrapper {
    & > .content {
      & > .UppHiringProcessDialogContent {
        padding: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-radius: 12px;

        & > .artwork {
          width: 64px;
          height: 64px;
          background-color: $color-feedback-warning-light;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 32px;

          & > svg {
            @include setSVGMonoColor($color-feedback-warning, null);
          }
        }

        & > h2 {
          @include headline-5;
          color: $color-black-high;
          margin: 0;
          text-align: center;
          max-width: 312px;
        }

        & > p {
          @include body-2;
          color: $color-black-medium;
          margin: 4px 0 24px 0;
          text-align: center;
          max-width: 312px;
        }

        & > .upp-steps-wrapper {
          padding: 16px;
          background-color: $color-neutral-light;
          border-radius: 12px;
        }
      }
    }
  }
}
</style>
